import { Tag } from "antd";
import { Link } from "react-router";
import { my_routes } from "../../router/all_routes";
import withPermission from "../../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";

const SummaryFooter = ({
  data,
  hourlyRate,
}: {
  data: any[];
  hourlyRate: number | null;
}) => {
  const routes = my_routes;

  // Total séances
  const totalSessions = data.reduce((sum, d) => sum + d.totalSessions, 0);

  // Total séances annulées
  const totalSessionsCancelled = data.reduce(
    (sum, d) => sum + d.totalAbsences,
    0,
  );

  // Total retard (en heures)
  const totalDelay = data.reduce((sum, d) => sum + (d.delay || 0), 0);
  const h_delay = Math.floor(totalDelay / 60);
  const m_delay = totalDelay % 60;

  // Total abscence (en heures)
  const totalAbsences = data.reduce(
    (sum, d) => sum + (d.totalHours - d.completedHours),
    0,
  );
  const h_absences = Math.floor(totalAbsences / 60);
  const m_absences = totalAbsences % 60;

  // Total abscence & retard (en heures)
  const totalAbsencesAndDelay = totalAbsences + totalDelay;
  const h_absences_and_delay = Math.floor(totalAbsencesAndDelay / 60);
  const m_absences_and_delay = totalAbsencesAndDelay % 60;

  // Total charge de travail (en heures)
  const totalHours = data.reduce((sum, d) => sum + d.totalHours, 0);
  const h = Math.floor(totalHours / 60);
  const m = totalHours % 60;

  // Total charge avec abscence (en heures)
  const totalHoursWithAbsences = data.reduce(
    (sum, d) => sum + d.completedHours,
    0,
  );

  // Total heures avec retard (en heures)
  const totalHoursWithDelay = totalHours - totalDelay;

  // Total heures avec retard et abscence (en heures)
  const totalHoursWithDelayAndAbsences =
    totalHours - totalDelay - (totalHours - totalHoursWithAbsences);

  // Total salaire
  const totalSalaryWithoutDelay = hourlyRate
    ? (totalHours / 60) * hourlyRate
    : 0;
  const totalSalaryWithDelay = hourlyRate
    ? (totalHoursWithDelay / 60) * hourlyRate
    : 0;
  const totalSalaryWithAbsences = hourlyRate
    ? (totalHoursWithAbsences / 60) * hourlyRate
    : 0;
  const totalSalaryWithDelayAndAbsences = hourlyRate
    ? (totalHoursWithDelayAndAbsences / 60) * hourlyRate
    : 0;

  return (
    <div className="mt-4 p-3 border rounded bg-light">
      <h6>Résumé du mois</h6>
      {/* Séances */}
      <div className="row mb-3">
        <div className="col-md-4">
          <p className="mb-1">
            Total séances : <strong>{totalSessions}</strong>
          </p>
          <p className="mb-1">
            Total séances annulées : <strong>{totalSessionsCancelled}</strong>
          </p>
          <p className="mb-0">
            Total séances effectuées :{" "}
            <strong>{totalSessions - totalSessionsCancelled} </strong>
          </p>
        </div>

        {/* Heures */}
        <div className="col-md-4">
          <p className="mb-1">
            Total Charge (heure) :{" "}
            <strong>{`${h}h ${m.toString().padStart(2, "0")} min`}</strong>
          </p>
          <p className="mb-1">
            Total absences (heure) :{" "}
            <strong>{`${h_absences}h ${m_absences
              .toString()
              .padStart(2, "0")} min`}</strong>
          </p>
          <p className="mb-1">
            Total retard (heure) :{" "}
            <strong>{`${h_delay}h ${m_delay
              .toString()
              .padStart(2, "0")} min`}</strong>
          </p>
          <p className="mb-0">
            Total retard & absences (heure) :{" "}
            <strong>{`${h_absences_and_delay}h ${m_absences_and_delay
              .toString()
              .padStart(2, "0")} min`}</strong>
          </p>
        </div>

        {/* Honoraire & Taux */}
        <div className="col-md-4">
          <p className="mb-1">
            <i className="fas fa-info-circle me-2"></i>
            Taux horaire :{" "}
            {hourlyRate === null ||
            hourlyRate === undefined ||
            hourlyRate === 0 ? (
              <Link
                className="text-decoration-underline text-primary"
                to={routes?.hourlyRateTeacher}
              >
                Définir taux horaire
              </Link>
            ) : (
              <strong>{`${hourlyRate} / h (FCFA)`}</strong>
            )}
          </p>
          <p className="mb-1">
            Honoraire sans (retard & abscence) ≈{" "}
            <strong>{`${totalSalaryWithoutDelay.toLocaleString(
              "fr-FR",
            )} FCFA`}</strong>
          </p>
          <p className="mb-1">
            Honoraire avec abscence ≈{" "}
            <strong>{`${totalSalaryWithAbsences.toLocaleString(
              "fr-FR",
            )} FCFA`}</strong>
          </p>
          <p className="mb-0">
            Honoraire avec retard ≈{" "}
            <strong>{`${totalSalaryWithDelay.toLocaleString(
              "fr-FR",
            )} FCFA`}</strong>
          </p>
          <p className="mb-1">
            Honoraire avec retard & abscence ≈{" "}
            <strong>{`${totalSalaryWithDelayAndAbsences.toLocaleString(
              "fr-FR",
            )} FCFA`}</strong>
          </p>
        </div>
      </div>

      <div>
        <Tag color="green">Cours normal</Tag>
        <Tag color="volcano">Rattrapage</Tag>
        <Tag color="geekblue">Normal</Tag>
        <Tag color="gold">Annulé</Tag>
        <Tag color="orange">Retard</Tag>
        <Tag color="orange">Absence</Tag>
      </div>
    </div>
  );
};

export default withPermission(
  SummaryFooter,
  [buildPermission(Resource.TEACHER_REPORT, Action.READ)],
  "masquer",
);
